import useSaveDomainToLocalStorage from './useSaveDomainToLocalStorage'

export default useSaveDomainToLocalStorage
